import axios from "axios";
import React, { useEffect, useState } from "react";
import PageBanner from "../Components/PageBanner";
import { useAuthContext } from "../Contexts/AuthContext";
import { toast } from "react-toastify";

const ResetPassword = ({ }) => {
  const { userdata } = useAuthContext();
  const [data, setData] = useState({});

  const onSubmit = async () => {
    if (data.newpassword === data.confirmpassword) {
      try {
        await axios.put(
          process.env.REACT_APP_BASE_URL + "/api/auth/changepassword",
          {
            email: userdata.email,
            oldpassword: data.oldpassword,
            newpassword: data.newpassword,
          }
        );

        toast.success("Successfully changed!</span>", {
          position: "top-center",
          theme: "dark"
        });

      } catch (err) {
        toast.error(err?.response?.data.msg, {
          position: "top-center",
          theme: "dark"
        });
      }
    } else {
      toast.error("¡Contraseñas no coinciden!</span>", {
        position: "top-center",
        theme: "dark"
      });
    }
  };

  useEffect(() => {
    const ScrollToTop = () => {
      window.scrollTo(0, 0);
    };
    ScrollToTop();
  }, []);

  return (
    <div>
      <PageBanner title={"Reset Password"} />
      <div className="mt-10 w-50 forgot_form py-3 mx-auto bg-white px-5 rounded shadow">
        <div>
          <label className="fw-bold">Contraseña antigua</label>
          <input
            type={"password"}
            // placeholder="Enter old password!"
            className="form-control mt-1 rounded-0"
            onChange={(e) => setData({ ...data, oldpassword: e.target.value })}
          />
        </div>
        <div className="mt-2">
          <label className="fw-bold">Nueva contraseña</label>
          <input
            type={"password"}
            // placeholder="Enter new password!"
            className="form-control mt-1 rounded-0"
            onChange={(e) => setData({ ...data, newpassword: e.target.value })}
          />
          <div className="mt-2">
            <label className="fw-bold">Confirma nueva contraseña</label>
            <input
              type={"password"}
              // placeholder="Confirm password!"
              className="form-control mt-1 rounded-0"
              onChange={(e) =>
                setData({ ...data, confirmpassword: e.target.value })
              }
            />
          </div>
          <button className="continue w-auto px-3 mx-auto" onClick={onSubmit}>
            Cambiar
          </button>
        </div>
      </div>
    </div>
  );
};

export default (ResetPassword);
